export default "__VITE_ASSET__75be5464__"